var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 295 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    height: "100%",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9442_80467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 54.8925L3.06557 51.3727C10.0159 57.7817 16.4234 60.762 25.7209 60.762C35.0183 60.762 41.6989 55.4352 41.6989 48.2105V48.0317C41.6989 41.3465 38.1782 37.4692 23.8256 34.58C8.66681 31.512 2.52592 26.364 2.52592 16.7927V16.614C2.52592 7.21825 11.1017 0 22.8406 0C32.0471 0 38.0937 2.52525 44.5076 7.67325L41.5298 11.3717C35.5742 6.22375 29.6122 4.24125 22.6618 4.24125C13.3643 4.24125 7.22343 9.568 7.22343 16.1622V16.341C7.22343 23.0262 10.6531 27.0887 25.6396 30.1535C40.2587 33.1305 46.3996 38.3662 46.3996 47.5767V47.7555C46.3996 57.9605 37.645 65 25.4608 65C15.3538 65 7.58753 61.659 0.00650174 54.8925H0Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1734 36.3197V5.35047H83.0467C94.4215 5.35047 102.181 10.5862 102.181 20.606V20.7847C102.181 30.174 94.2362 36.3132 82.5038 36.3132H72.075V40.6422H82.2372C95.4162 40.6422 106.882 33.7782 106.882 20.5085V20.3297C106.882 8.14222 97.3115 1.01172 83.4108 1.01172H60.4824V64.2145H65.1767V40.6487",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.211 33.788V5.35047H203.781C215.246 5.35047 221.92 10.6772 221.92 19.163V19.3417C221.92 28.4612 214.063 33.788 203.504 33.788H189.145V38.0292H202.874L223.003 64.208H228.959L208.108 37.2102C218.757 35.7672 226.611 29.7157 226.611 19.1565V18.9777C226.611 14.4635 224.807 10.2222 221.829 7.24197C218.036 3.44597 211.814 1.01172 204.047 1.01172H177.51V64.2145H182.205V38.0357",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.117 31.9764L239.934 1.01367H245.532L267.101 28.9084L288.583 1.01367H294.093L269.812 31.9829L295 64.2164H289.402L266.926 35.0574L244.537 64.2164H239.027L264.117 31.9829V31.9764Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.194 10.309L159.484 59.6603H110.842L135.194 10.309ZM135.2 0L103.514 64.2168H166.809L135.2 0Z",
    fill: "url(#paint0_linear_9442_80467)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9442_80467",
    x1: 107.984,
    y1: 68.3865,
    x2: 155.322,
    y2: 28.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#652092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F54DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FF83B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9442_80467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.c2bd65941a1635e2725ba628100c654f.svg";
export { ForwardRef as ReactComponent };